// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HypotheticalTransferModal_PrincipalFragment = { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null };

export type HypotheticalTransferModal_EstateWaterfallHypotheticalTransferFragment = { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string, startYear?: number | null, endYear?: number | null, taxDiscount?: Percent | null, name?: string | null, assetGrowthReturn?: Percent | null, transferValue?: CurrencyUSD | null, taxableValue?: CurrencyUSD | null, transferTaxKind: Types.EstateWaterfallHypotheticalTransferTransferTaxKind, destinationKind: Types.EstateWaterfallHypotheticalTransferDestinationKind, sourceKind: Types.EstateWaterfallHypotheticalTransferSourceKind, isGstGift: boolean, transferOrder: number, destinationEntity?: { __typename?: 'Entity', id: string, stage: Types.EntityStage, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string, grantors?: Array<(
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      )> | null } | { __typename?: 'CRTTrust', id: string, displayName: string, grantors?: Array<(
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      )> | null } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string, donors?: Array<(
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      )> | null } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string, grantor?: (
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      ) | null } | { __typename?: 'ILITTrust', id: string, displayName: string, grantors?: Array<(
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      )> | null } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, owner?: (
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      ) | null } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string, grantors?: Array<(
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      )> | null } | { __typename?: 'JointPersonalAccount', id: string, displayName: string, owners?: Array<(
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      )> | null } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string, donors?: Array<(
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      )> | null } | { __typename?: 'QPRTTrust', id: string, displayName: string, grantors?: Array<(
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      )> | null } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, owner?: (
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      ) | null } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string, owner?: (
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      ) | null } | { __typename?: 'RevocableTrust', id: string, displayName: string, grantors?: Array<(
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      )> | null } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string, grantor?: (
        { __typename?: 'Principal' }
        & HypotheticalTransferModal_PrincipalFragment
      ) | null } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, destinationIndividual?: { __typename?: 'ClientProfile', id: string } | null, destinationOrganization?: { __typename?: 'ClientOrganization', id: string } | null, sourceEntity?: { __typename?: 'Entity', id: string, kind: Types.EntityKind } | null, sourceIndividual?: { __typename?: 'ClientProfile', id: string } | null, giftingGrantors?: Array<{ __typename?: 'ClientProfile', id: string }> | null, sourceOwnedEntity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, sourceInsurancePolicy?: { __typename?: 'InsurancePolicy', id: string, carrierName?: string | null } | null };

export type HypotheticalTransferModal_EstateWaterfallFragment = { __typename?: 'EstateWaterfall', id: string, allTransfers: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', totalCount: number }, hypotheticalTransfers?: { __typename?: 'EstateWaterfallHypotheticalTransferConnection', edges?: Array<{ __typename?: 'EstateWaterfallHypotheticalTransferEdge', node?: (
        { __typename?: 'EstateWaterfallHypotheticalTransfer' }
        & HypotheticalTransferModal_EstateWaterfallHypotheticalTransferFragment
      ) | null } | null> | null } };

export type HypotheticalTransferModalQueryVariables = Types.Exact<{
  waterfallId: Types.Scalars['ID']['input'];
  transferId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  hasExistingTransfer: Types.Scalars['Boolean']['input'];
}>;


export type HypotheticalTransferModalQuery = { __typename?: 'Query', estateWaterfalls: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall' }
        & HypotheticalTransferModal_EstateWaterfallFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    HypotheticalTransferModal: 'HypotheticalTransferModal' as const
  },
  Fragment: {
    HypotheticalTransferModal_Principal: 'HypotheticalTransferModal_Principal' as const,
    HypotheticalTransferModal_EstateWaterfallHypotheticalTransfer: 'HypotheticalTransferModal_EstateWaterfallHypotheticalTransfer' as const,
    HypotheticalTransferModal_EstateWaterfall: 'HypotheticalTransferModal_EstateWaterfall' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const HypotheticalTransferModal_PrincipalFragmentDoc = gql`
    fragment HypotheticalTransferModal_Principal on Principal {
  id
  individual {
    id
  }
}
    `;
export const HypotheticalTransferModal_EstateWaterfallHypotheticalTransferFragmentDoc = gql`
    fragment HypotheticalTransferModal_EstateWaterfallHypotheticalTransfer on EstateWaterfallHypotheticalTransfer {
  id
  startYear
  endYear
  taxDiscount
  name
  assetGrowthReturn
  transferValue
  taxableValue
  transferTaxKind
  destinationKind
  destinationEntity {
    id
    stage
    kind
    subtype {
      id
      displayName
      ... on IrrevocableTrust {
        grantors {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on RevocableTrust {
        grantors {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on SLATTrust {
        grantor {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on GRATTrust {
        grantor {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on ILITTrust {
        grantors {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on QPRTTrust {
        grantors {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on IndividualPersonalAccount {
        owner {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on JointPersonalAccount {
        owners {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on RetirementPersonalAccount {
        owner {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on QualifiedTuitionPersonalAccount {
        owner {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on CRTTrust {
        grantors {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on CLTTrust {
        grantors {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on DonorAdvisedFund {
        donors {
          ...HypotheticalTransferModal_Principal
        }
      }
      ... on PrivateFoundation {
        donors {
          ...HypotheticalTransferModal_Principal
        }
      }
    }
  }
  destinationIndividual {
    id
  }
  destinationOrganization {
    id
  }
  sourceEntity {
    id
    kind
  }
  sourceIndividual {
    id
  }
  sourceKind
  giftingGrantors {
    id
  }
  isGstGift
  transferOrder
  sourceOwnedEntity {
    id
    subtype {
      id
      displayName
    }
  }
  sourceInsurancePolicy {
    id
    carrierName
  }
}
    ${HypotheticalTransferModal_PrincipalFragmentDoc}`;
export const HypotheticalTransferModal_EstateWaterfallFragmentDoc = gql`
    fragment HypotheticalTransferModal_EstateWaterfall on EstateWaterfall {
  id
  allTransfers: hypotheticalTransfers {
    totalCount
  }
  hypotheticalTransfers(where: {id: $transferId}, first: 1) @include(if: $hasExistingTransfer) {
    edges {
      node {
        ...HypotheticalTransferModal_EstateWaterfallHypotheticalTransfer
      }
    }
  }
}
    ${HypotheticalTransferModal_EstateWaterfallHypotheticalTransferFragmentDoc}`;
export const HypotheticalTransferModalDocument = gql`
    query HypotheticalTransferModal($waterfallId: ID!, $transferId: ID, $hasExistingTransfer: Boolean!) {
  estateWaterfalls(where: {id: $waterfallId}, first: 1) {
    edges {
      node {
        ...HypotheticalTransferModal_EstateWaterfall
      }
    }
  }
}
    ${HypotheticalTransferModal_EstateWaterfallFragmentDoc}`;

/**
 * __useHypotheticalTransferModalQuery__
 *
 * To run a query within a React component, call `useHypotheticalTransferModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useHypotheticalTransferModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHypotheticalTransferModalQuery({
 *   variables: {
 *      waterfallId: // value for 'waterfallId'
 *      transferId: // value for 'transferId'
 *      hasExistingTransfer: // value for 'hasExistingTransfer'
 *   },
 * });
 */
export function useHypotheticalTransferModalQuery(baseOptions: Apollo.QueryHookOptions<HypotheticalTransferModalQuery, HypotheticalTransferModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HypotheticalTransferModalQuery, HypotheticalTransferModalQueryVariables>(HypotheticalTransferModalDocument, withFetchPolicyContext(options));
      }
export function useHypotheticalTransferModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HypotheticalTransferModalQuery, HypotheticalTransferModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HypotheticalTransferModalQuery, HypotheticalTransferModalQueryVariables>(HypotheticalTransferModalDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useHypotheticalTransferModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HypotheticalTransferModalQuery, HypotheticalTransferModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HypotheticalTransferModalQuery, HypotheticalTransferModalQueryVariables>(HypotheticalTransferModalDocument, withFetchPolicyContext(options));
        }
export type HypotheticalTransferModalQueryHookResult = ReturnType<typeof useHypotheticalTransferModalQuery>;
export type HypotheticalTransferModalLazyQueryHookResult = ReturnType<typeof useHypotheticalTransferModalLazyQuery>;
export type HypotheticalTransferModalSuspenseQueryHookResult = ReturnType<typeof useHypotheticalTransferModalSuspenseQuery>;
export type HypotheticalTransferModalQueryResult = Apollo.QueryResult<HypotheticalTransferModalQuery, HypotheticalTransferModalQueryVariables>;